import type { MailboxInfo } from "owa-client-types";
import type NotificationPayloadBase from "owa-service/lib/contract/NotificationPayloadBase";
import { action } from "satcheljs";

export interface FLEXIBLEWORKINGHOURS_NOTIFICATIONActionMessage {
    notification: NotificationPayloadBase;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (notification: NotificationPayloadBase, mailboxInfo?: MailboxInfo) => FLEXIBLEWORKINGHOURS_NOTIFICATIONActionMessage = action("FLEXIBLEWORKINGHOURS_NOTIFICATION", (notification: NotificationPayloadBase, mailboxInfo?: MailboxInfo): FLEXIBLEWORKINGHOURS_NOTIFICATIONActionMessage => ({
    notification,
    mailboxInfo,
}));
export default defaultExport;
